module.exports = __webpack_public_path__ + "img/btn_home.974a2ebb.png";